import { render, staticRenderFns } from "./VendingPanel.vue?vue&type=template&id=ff39b8c2"
import script from "./VendingPanel.vue?vue&type=script&lang=js"
export * from "./VendingPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports